<template>
  <section class="section mobile_div section_bg  " >
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <div v-if="is_load" class="">
      <nav aria-label="breadcrumb" class="section_header mobile_div d-flex justify-content-center"  >
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link tag="a" :to="{name: 'project',params:{id:main_project.last_id}}">
            {{ main_project.name_project }}
          </router-link></li>

          <li class="breadcrumb-item active" aria-current="page">Новая задача</li>
        </ol>
      </nav>
      <div class="container-fluid mobile_div" >
        <div class="second_section ">
          <h2 class="text-center">Добавить новую задачу</h2>
          <div class="">



            <div class="form-group row" v-if="role=='developer' || main_project.manage_spectator==1"
            >
              <div class="col-12 col-md-6">
                <label for="exampleUser">Исполнитель задачи</label>
              </div>
              <div class="col-12 col-md-6">
                <select id="exampleUser" required v-model="newProject.developer_id"
                    class="form-control">

                  <option
                      v-for="user_project in users"
                      :value="user_project.last_id"
                      :key="user_project.last_id">@{{
                      user_project.name
                    }}
                  </option>

                </select>
              </div>



            </div>

            <div class="form-group row" v-if="role=='developer' || main_project.manage_spectator==1"
            >
              <div class="col-12 col-md-6">
                <label for="exampleUser">Ответственный</label>
              </div>
              <div class="col-12 col-md-6">
                <select id="exampleUser" required v-model="newProject.client_id"
                    class="form-control">

                  <option
                      v-for="user_project in users"
                      :value="user_project.last_id"
                      :key="user_project.last_id">@{{
                      user_project.name
                    }}
                  </option>

                </select>
              </div>



            </div>
            <div class="row form-group"  v-for="field in newProject.fields"   :key="field.last_id">
              <div class="col-md-6">
                <label for="exampleCategory">{{ field.title}} </label>
              </div>
              <div class="col-md-6">
                <select  id="exampleCategory" v-if="field.type=='select' || field.type=='selectinsert'" v-model="newProject.custom_fields[field.name]"

                    class="form-control">
                  <option value="null" v-if="field.type=='selectinsert'">Создать новый</option>
                  <option v-for="value in field.values" :value="value.last_id" :key="value.last_id">
                    {{ value[field.key_title] }}
                  </option>

                </select>

                <select  id="exampleCategory"   v-if="field.type=='selectteam'" v-model="newProject.custom_fields[field.name]"

                    class="form-control">
                  <option :value="'null'" >Не указан</option>
                  <option v-for="team_user in field.users" :value="team_user.last_id" :key="team_user.last_id">
                    {{ team_user.name }}
                  </option>

                </select>

                <input class="form-control" type="text"  v-if="field.type=='selectinsert' && newProject.custom_fields[field.name]=='null' " v-model="project.custom_fields[field.name+'_input']"/>
                <input class="form-control" type="number" v-if="field.type=='number'" v-model="newProject.custom_fields[field.name]"/>
                <input class="form-control" type="text" v-if="field.type=='stroka'" v-model="newProject.custom_fields[field.name]"/>
              </div>






            </div>
            <editorjsinput :blocks_json="example_blocks" ref="editorjs" ></editorjsinput>


            <div class="alert alert-danger" v-if="iserror==true">
              <p>{{ error_message }}</p>
            </div>
            <p class="text-center"><base-button  @click="onSave" >Создать задачу</base-button></p>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>
<script>
import Api from "@/models/Api";
import Editorjsinput from "@/models/Editorjsinput";
import UserModel from "@/models/UserModel";
import {eventBus} from "../../main";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "AddTask",
  data() {

    var app = this;

    return {


      'main_project':null,
      'newProject':{

        "i_am_client_and_developer":false,
        "category":"",
        'custom_fields':{},
        'fields':[],

      },
      'example_blocks':[


      ],
      'is_load':false,
      'categorys':[],
      'iserror':false,
      'error_message':'',
      'isdeveloper':false,
      'user':null,
      'users':[]





    }
  },
  mounted: function () {
    var app = this;

    let id = app.$route.params.id;
    var user=UserModel.get();

    if(user && user.last_id){
      app.user=user;
      Api.loadProjectv2(id,function(data){
        app.main_project=data.project;
        app.role=data.role;
        app.users=data.users;
        app.newProject.fields=data.project.fields;
        app.newProject.custom_fields={};
        if((app.main_project.client_id==user.last_id || (app.main_project.status_row.issearch==0 && app.role=='developer') || (app.main_project && app.main_project.manage_spectator==1) )){


          if(app.role=='developer'){
            app.newProject.developer_id='me';
          }




          app.newProject.fields.map(function(field) {
            var new_field={};

            app.newProject.custom_fields[field.name] = "";
            if (field.type == "selectinsert") {
              app.newProject.custom_fields[field.name + "_input"] = "";
            }
          });


          app.is_load=true;

        }
      });
    }








  },components: {
    'editorjsinput': Editorjsinput,LoadingBlock
  },methods:{

    onSave(){
      var app=this;
      app.is_load=false;
      app.$refs.editorjs.save(function(editor_js_data){

        app.example_blocks=editor_js_data.blocks;

        var edit_project = {'fields':app.newProject.custom_fields,"last_id": app.main_project.last_id, "json": editor_js_data};
        edit_project.developer = app.newProject.developer_id;
        edit_project.client=app.newProject.client_id;
        Api.addTask(edit_project, function (tasks) {
          app.is_load=true;
          app.iserror = false;

          var last_el=tasks.length-1;
          var cur_task=tasks[last_el];


          app.$router.push({name: 'project', params: {id: cur_task.last_id, "rand": Math.random()}});





        }, function (message) {
          app.is_load=true;
          app.iserror = true;
          app.error_message = message;
        })





      });
    },


  },
}
</script>

<style scoped>

</style>